import { render } from "./OrderBranchSelector.vue?vue&type=template&id=810c2b8e"
import script from "./OrderBranchSelector.vue?vue&type=script&lang=js"
export * from "./OrderBranchSelector.vue?vue&type=script&lang=js"

import "./OrderBranchSelector.vue?vue&type=style&index=0&id=810c2b8e&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__